<h2 mat-dialog-title>
  <mat-icon class="title-icon">feedback</mat-icon>
  Report an Issue
</h2>

<mat-dialog-content>
  <div class="feedback-form">
    <!-- Category -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Category</mat-label>
      <mat-select [(ngModel)]="category">
        @for (cat of categories; track cat.value) {
          <mat-option [value]="cat.value">
            <mat-icon class="option-icon">{{ cat.icon }}</mat-icon>
            {{ cat.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- Description -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Describe the problem</mat-label>
      <textarea
        matInput
        [(ngModel)]="description"
        placeholder="What happened? What did you expect?"
        rows="5"
        maxlength="10000"
        cdkTextareaAutosize
        cdkAutosizeMinRows="4"
        cdkAutosizeMaxRows="12"
      ></textarea>
      <mat-hint align="end">{{ description.length }} / 10,000</mat-hint>
    </mat-form-field>

    @if (data.diagnosticItems?.length) {
      <section class="diagnostic-summary" aria-labelledby="diagnostic-summary-title">
        <div class="diagnostic-summary-title" id="diagnostic-summary-title">
          <mat-icon>fact_check</mat-icon>
          Diagnostic context included
        </div>
        <ul>
          @for (item of data.diagnosticItems; track item) {
            <li>{{ item }}</li>
          }
        </ul>
        <p>Credentials, cookies, authentication headers, and raw exception details are not collected.</p>
      </section>
    }

    <!-- Consent and Context -->
    <div class="feedback-options">
      <mat-checkbox [(ngModel)]="userConsent" color="primary" class="consent-checkbox">
        Consent to include my username and email in the report
      </mat-checkbox>
      <p class="consent-hint">Required to help us follow up with you on this issue.</p>

      @if (data.chatLogJson) {
        <mat-checkbox [(ngModel)]="includeChatLog" color="primary"> Include chat conversation log </mat-checkbox>
        <p class="chat-log-hint">The full chat history will be attached to the issue for context.</p>
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <span [matTooltip]="submitTooltip" matTooltipPosition="above">
    <button mat-flat-button color="primary" (click)="submit()" [disabled]="isSubmitDisabled">Submit</button>
  </span>
</mat-dialog-actions>
